import { render, staticRenderFns } from "./SustainabilityPieChart.vue?vue&type=template&id=40f20c74"
import script from "./SustainabilityPieChart.vue?vue&type=script&lang=js"
export * from "./SustainabilityPieChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports